module.exports = __webpack_public_path__ + "img/change-position.8f1a6313.svg";